// PersonLabel — renders a human-readable name for a raw user id (Epic E9, AC-UX-3).
//
// The resolved display name is the PRIMARY visible text; the raw id stays available in the
// `title` attribute (hover/tap disclosure) and optionally as an inline `showId` detail.
// Unknown ids fall back to the raw id so nothing is fabricated.
//
// Import by direct path (not via components/index.js):
//   import { PersonLabel } from '../../components/primitives/PersonLabel.jsx';

import { usePeople } from '../../lib/usePeople.js';

export function PersonLabel({ userId, fallback = 'unassigned', showId = false, className = '' }) {
  const { nameOf } = usePeople();

  if (!userId) {
    return <span className={className || undefined}>{fallback}</span>;
  }

  const id = String(userId);
  const name = nameOf(id);
  const resolved = name !== id;

  return (
    <span
      className={`person-label${className ? ` ${className}` : ''}`}
      title={resolved ? `${name} (${id})` : id}
      data-user-id={id}
    >
      {name}
      {showId && resolved ? <span className="muted small"> ({id})</span> : null}
    </span>
  );
}
